import { Component, Input, OnInit, inject } from "@angular/core";
import { FormControl, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogTitle, MatDialogActions, MatDialogClose } from "@angular/material/dialog";
import { MatButton } from "@angular/material/button";

@Component({
    selector: "app-ask-confirmation-dialog",
    template: `
    <section>
      <h4 mat-dialog-title>{{ data.title || "Vuoi confermare l'eliminazione?" }}</h4>

      <section class="d-flex justify-content-center" mat-dialog-actions>
        <button mat-flat-button mat-dialog-close>Annulla</button>

        <button
          mat-flat-button
          color="warn"
          [mat-dialog-close]="true"
          class="ms-3"
        >
          Conferma
        </button>
      </section>
    </section>
  `,
    imports: [MatDialogTitle, MatDialogActions, MatButton, MatDialogClose]
})
export class EntityDeleteConfirmationDialogComponent {
  data = inject<{
    title: string;
}>(MAT_DIALOG_DATA);
}
